<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-text>
          <v-alert :value="success" type="success" outline>Se envió un mail a la casilla ingresada.</v-alert>
          <v-container>
            <form @submit.prevent="requestPasswordReset">
              <v-text-field name="email" label="Email" id="email" v-model="email" type="email"
                required></v-text-field>
              <v-btn type="submit">Recuperar contraseña</v-btn>
            </form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      success: false,
      email: '',
      passwordResetPath: '/password_reset'
    }
  },

  methods: {
    showDialog () {
      this.dialog = true
    },
    hideDialog () {
      this.dialog = false
    },
    getPayload () {
      return {
        'email': this.email
      }
    },
    requestPasswordReset () {
      this.axios.post(this.passwordResetPath, this.getPayload())
        .then(() => {
          this.success = true
        }).catch((error) => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  }
}
</script>
